import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSticker: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSticker"><Path d="M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 11.8323 21.4957 11.6656 21.4871 11.5L12.5 2.51293C12.3344 2.50435 12.1677 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5Z" stroke="currentColor"/><Path d="M12.4993 3C11.9992 8 15.9993 12 20.9994 11.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSticker;
